// extracted by mini-css-extract-plugin
module.exports = {"star":"Star_star__80s_H","star_item":"Star_star_item__3RJvb"};